/** Lets a reply referencing this frame read the things currently lit on its globe. */
import { useEffect, useRef } from "react";
import { registerMemoryFrameView } from "@/lib/memory-frame-view";

export function useMemoryFrameView(
  frameId: string,
  litIds: readonly string[],
): void {
  const lit = useRef(litIds);
  useEffect(() => {
    lit.current = litIds;
  }, [litIds]);
  useEffect(
    () => registerMemoryFrameView(frameId, () => ({ litIds: lit.current })),
    [frameId],
  );
}
